import { Hero } from "../sections/hero";
import { HowItWorks } from "../sections/how-it-works";
import { Pricing } from "../sections/pricing";
import { Services } from "../sections/services";
// import { Testimonials } from "../sections/testimonials"; // hidden for now

export default function Landing() {
  return (
    <>
      <Hero />
      <Pricing />
      <Services />
      <HowItWorks />
      {/* <Testimonials /> hidden for now — re-enable when we have real quotes */}
    </>
  );
}
